export default __webpack_public_path__ + "media/color/sberbank-ab13d663.svg";